import { createNamespacedHelpers } from 'vuex'
const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

import summaryMixin from '@/components/AttendanceForm/espondiloartrites/mixins/espondiloartritesSummaryMixin'

export default {
  mixins: [summaryMixin],

  methods: {
    isPainCriteriaPositive(pain, patientBirthday, minMonths = 3, maxAge = 45) {
      return (
        !!pain.value &&
        ((pain.period.type === 'ANO' && parseInt(pain.period.length) > 0) ||
          (pain.period.type === 'MES' && parseInt(pain.period.length) >= minMonths)) &&
        this.$moment()
          .subtract(parseInt(pain.period.length), pain.period.type === 'ANO' ? 'year' : 'month')
          .diff(this.$moment(patientBirthday), 'years') < maxAge
      )
    },
  },
  computed: {
    ...attendanceGettersMap(['getPhaseDataByKey', 'attendance']),
    painCriteriaResult() {
      const symptomPhaseData = this.getPhaseDataByKey('sintomas')
      const dorNadega = symptomPhaseData.symptoms.dor_nadega
      const dorLombar = symptomPhaseData.symptoms.dor_lombar
      return (
        this.isPainCriteriaPositive(dorNadega, this.attendance.patient.birthday) ||
        this.isPainCriteriaPositive(dorLombar, this.attendance.patient.birthday)
      )
    },
    elementCriteriaResult() {
      const hla_b27 = this.getPhaseDataByKey('asas').hla_b27

      if (
        (!hla_b27 && this.computedSacroileiteImagem === '?') ||
        (hla_b27 == null && this.computedSacroileiteImagem === '-')
      ) {
        return null
      }

      const conditionA = this.computedSacroileiteImagem === '+' && this.computedCaracteristicas >= 1
      const conditionB = hla_b27 && this.computedCaracteristicas >= 2

      return conditionA || conditionB
    },
    computedAsasAxial() {
      if (
        !this.getPhaseDataByKey('sintomas') ||
        !this.getPhaseDataByKey('asas') ||
        this.painCriteriaResult == null ||
        this.elementCriteriaResult == null
      ) {
        return '?'
      }
      const positive = this.painCriteriaResult && this.elementCriteriaResult
      return positive ? '+' : '-'
    },
    computedCaracteristicas() {
      const asasPhaseKeys = [
        'boa_resposta_aine',
        'doenca_de_crohn_ou_retocolite_ulcerativa',
        'historia_familiar_espondiloartrite',
        'hla_b27',
        'proteina_c_reativa_elevada',
      ]
      const symptomsPhaseKeys = ['artrite_artralgia', 'entesite', 'uveite', 'dactilite', 'psoriase']

      if (!this.getPhaseDataByKey('sintomas') && !this.getPhaseDataByKey('asas')) {
        return '?'
      }

      return (
        (!this.getPhaseDataByKey('asas')
          ? 0
          : asasPhaseKeys.reduce((prev, key) => prev + (this.getPhaseDataByKey('asas')[key] ? 1 : 0), 0)) +
        (!this.getPhaseDataByKey('sintomas')
          ? 0
          : symptomsPhaseKeys.reduce(
              (prev, key) => prev + (this.getPhaseDataByKey('sintomas').symptoms[key]?.value ? 1 : 0),
              0,
            ))
      )
    },
    computedSummarizedFlow() {
      return this.getPhaseDataByKey('summarizedFlow')
    },
    computedMda() {
      if (this.getPhaseDataByKey('mda')?.mda === undefined || this.getPhaseDataByKey('mda')?.mda === null) {
        return '?'
      }
      return this.getPhaseDataByKey('mda')?.mda ? '+' : '-'
    },
    computedBasdai() {
      const keyListOne = [
        'nivel_fadiga',
        'nivel_dor_coluna',
        'nivel_dor_articulacoes',
        'nivel_desconforto_areas_dolorosas',
      ]
      const keyListTwo = ['nivel_desconforto_matinal', 'tempo_rigidez_matinal']
      const atividades = this.getPhaseDataByKey('atividades_doenca')
      if (
        !atividades ||
        keyListOne.some((key) => atividades[key] == null) ||
        keyListTwo.some((key) => atividades[key] == null)
      ) {
        return '?'
      }

      let result =
        keyListOne.reduce((prev, key) => prev + atividades[key], 0) +
        keyListTwo.reduce((prev, key) => prev + atividades[key], 0) / 2
      result = result / 5
      return result
    },
    computedAsdasPcr() {
      const keys = [
        'nivel_dor_coluna',
        'tempo_rigidez_matinal',
        'escala_global',
        'nivel_dor_articulacoes',
        'proteina_c_reativa',
      ]
      const weights = [0.12, 0.06, 0.11, 0.07, 0.58]

      if (
        !this.getPhaseDataByKey('atividades_doenca') ||
        keys.some((key) => this.getPhaseDataByKey('atividades_doenca')[key] == null) ||
        this.getPhaseDataByKey('atividades_doenca')['proteina_c_reativa'].dosageUnit == null
      ) {
        return '?'
      }

      return keys
        .reduce((prev, key, index) => {
          let weight = weights[index]
          let value = this.getPhaseDataByKey('atividades_doenca')[key]
          if (key === 'proteina_c_reativa') {
            if (value.dosageUnit === 'MG_DL') {
              value = Math.log(Number(value.value) * 10 + 1)
            } else {
              value = Math.log(Number(value.value) + 1)
            }
          }

          return Math.round((prev + weight * value) * 100) / 100
        }, 0)
        .toFixed(2)
    },
    computedAsdasVhs() {
      const keys = [
        'nivel_dor_coluna',
        'tempo_rigidez_matinal',
        'escala_global',
        'nivel_dor_articulacoes',
        'velocidade_hemossedimentacao_vhs',
      ]
      const weights = [0.08, 0.07, 0.11, 0.09, 0.29]

      if (
        !this.getPhaseDataByKey('atividades_doenca') ||
        keys.some((key) => this.getPhaseDataByKey('atividades_doenca')[key] == null) ||
        this.getPhaseDataByKey('atividades_doenca')?.velocidade_hemossedimentacao_vhs?.value == null
      ) {
        return '?'
      }

      return keys.reduce((prev, key, index) => {
        let weight = weights[index]
        let value = this.getPhaseDataByKey('atividades_doenca')[key]
        if (key === 'velocidade_hemossedimentacao_vhs') {
          value = Math.sqrt(Number(value.value))
        }

        return Math.round((prev + weight * value) * 100) / 100
      }, 0)
    },
  },
}
